import { render, staticRenderFns } from "./InvoiceTable.vue?vue&type=template&id=5288769c&scoped=true"
import script from "./InvoiceTable.vue?vue&type=script&lang=js"
export * from "./InvoiceTable.vue?vue&type=script&lang=js"
import style0 from "./InvoiceTable.vue?vue&type=style&index=0&id=5288769c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5288769c",
  null
  
)

export default component.exports